export enum AmplificationStatusAPIEnum {
    ONLINE_BOOST = 'BOOST',
    NEWSROOM = 'NEWSROOM'
}
